export enum IconStyle {
    Solid = 'fas',
    Light = 'fal',
}
